module.exports = __webpack_public_path__ + "media/images/front/icon_mymenu-b22ff88d3b68b13df156f0d149a19fae.png";